import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'SCHOOL_PERFORMANCE_GET',
  GET_SUCCESS: 'SCHOOL_PERFORMANCE_GET_SUCCESS',
  GET_FAILURE: 'SCHOOL_PERFORMANCE_GET_FAILURE',

  PATCH: 'SCHOOL_PERFORMANCE_PATCH',
  PATCH_SUCCESS: 'SCHOOL_PERFORMANCE_PATCH_SUCCESS',
  PATCH_FAILURE: 'SCHOOL_PERFORMANCE_PATCH_FAILURE',

  POST: 'SCHOOL_PERFORMANCE_POST',
  POST_SUCCESS: 'SCHOOL_PERFORMANCE_POST_SUCCESS',
  POST_FAILURE: 'SCHOOL_PERFORMANCE_POST_FAILURE',
};

export const get = actions.get(
  performanceId => `${BASE_URL}/student-exams/form/${performanceId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(
  performanceId => `${BASE_URL}/student-exams/form/${performanceId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const post = actions.post(
  (id, data, performanceId) => `${BASE_URL}/student-exams/form/${performanceId}/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);
